module.exports = __webpack_public_path__ + "static/media/F-1-mobile.60a6166c.webp";